<template>
    <div class="side-nav flex-column-reverse flex-lg-column position-relative" style="display: flex; z-index: 2">
        <div class="justify-content-between side-nav-padding d-none d-lg-flex">
            <h2>{{$trans('storefront::image_editor.custom_stickers')}}</h2>

            <button type="button" class="btn d-flex p-0 gap-2 align-items-center text-uppercase font-weight-bold" @click="handleCloseClick">
                <div>{{$trans('storefront::image_editor.close')}}</div> <i class="las la-times"></i>
            </button>
        </div>

        <div class="position-relative">
            <div class="d-flex justify-content-center justify-content-lg-start user-select-none bg-white" style="position: relative; z-index: 101">
                <div class="nav-item nav-item-vertical" data-value="upload-file" :class="{ active: isActive('upload-file') }" @click="handleClick">
                    <img :src="$getImg('icons/upload-file-icon@2x.png')" class="nav-item-icon">
                    {{$trans('storefront::image_editor.upload_file')}}
                </div>

                <div class="nav-item nav-item-vertical" data-value="cutline" :class="{ active: isActive('cutline') }" @click="handleClick">
                    <img :src="$getImg('icons/cutline-icon@2x.png')" class="nav-item-icon">
                    {{$trans('storefront::image_editor.cutline')}}
                </div>

                <div class="nav-item nav-item-vertical" data-value="material" :class="{ active: isActive('material') }" @click="handleClick">
                    <img :src="$getImg('icons/material-icon@2x.png')" class="nav-item-icon">
                    {{$trans('storefront::image_editor.material')}}
                </div>

                <div class="nav-item nav-item-vertical" data-value="insert-text" :class="{ active: isActive('insert-text') }" @click="handleClick">
                    <img :src="$getImg('icons/insert-text-icon@2x.png')" class="nav-item-icon">
                    {{$trans('storefront::image_editor.insert_text')}}
                </div>

                <div class="nav-item nav-item-vertical" data-value="background" :class="{ active: isActive('background') }" @click="handleClick" v-if="store.can_edit_background">
                    <img :src="$getImg('icons/background-icon@2x.png')" class="nav-item-icon">
                    {{$trans('storefront::image_editor.background')}}
                </div>
            </div>

            <div v-if="open && value !== ''" class="position-absolute w-100 d-lg-none bg-white" style="bottom: 100%; z-index: 100; max-height: 60vh; overflow: auto">
                <div class="bg-white">
                    <component :is="value"></component>
                </div>
                <hr class="my-0">
                <div class="d-flex justify-content-end side-nav-padding">
                    <button type="button" class="btn btn-secondary" @click="closeCategory" style="min-width: 120px">{{$trans('storefront::image_editor.done')}}</button>
                </div>
            </div>

            <div v-if="value !== ''" class="d-none d-lg-block" style="background: var(--nav-control-bg);">
                <component :is="value"></component>
            </div>
        </div>

        <div class="position-relative">
            <div class="d-flex justify-content-center" style="position: absolute; top: 0; left: 0; right: 0">
                <div style="position: relative; top: -22px">
                    <!--SETTINGS CARD TOGGLE-->
                    <button type="button" class="btn dropdown-toggle-button" style="font-size: 15px; min-width: 75px; min-height: 26px" @click="settingCardOpen = !settingCardOpen">
                        <i class="las la-angle-up" :class="{'rotate-180' : settingCardOpen}" style="transition: transform 0.3s;"></i>
                    </button>
                </div>
            </div>

            <div v-if="settingCardOpen" class="d-flex justify-content-center flex-grow-1" :class="{'overlay-hidden-lg': open}">
                <div class="d-flex flex-column navigation-column gap-3 flex-grow-1">
                    <sticker-settings-card></sticker-settings-card>

                    <div class="settings-card-group d-flex justify-content-end justify-content-lg-center">
                        <button type="button" :disabled="store.loading" class="btn btn-primary btn-large text-uppercase" @click="addToCart" style="min-width: 160px">
                            <template v-if="store.loading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span class="sr-only">{{$trans('storefront::image_editor.loading')}}</span>
                            </template>
                            <template v-else>
                                {{$trans('storefront::image_editor.add_to_cart')}}
                            </template>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UploadFile from "./actions/UploadFile";
import Cutline from "./actions/Cutline";
import InsertText from "./actions/InsertText";
import Material from "./actions/Material";
import Background from "./actions/Background";
import {useImageEditorStore} from "./store";
import StickerSettingsCard from "./StickerSettingsCard";
import ProductCardMixin from "../../mixins/ProductCardMixin";
import getImageEditor, {isMobileDevice} from "./imageEditor";
import {confirmClose} from "./js/actions";

export default {
    components: {Background, Material, InsertText, Cutline, UploadFile, StickerSettingsCard},
    mixins: [
        ProductCardMixin
    ],
    setup() {
        const store = useImageEditorStore();

        return {
            store: store,
        }
    },
    data() {
        return {
            value: 'upload-file',
            open: false,
            settingCardOpen: true,
        }
    },
    beforeMount() {
        window.settingCard_toggle = this.settingCard_toggle;
    },
    mounted() {
        if (isMobileDevice()) {
            this.value = '';
            this.settingCardOpen = false;
        }
    },
    watch: {
        settingCardOpen(newVal, oldVal) {
            if(newVal !== oldVal) {
                this.$nextTick(() => {
                    window.imageEditor.onResize();
                });
            }
        }
    },
    methods: {
        isActive(dataValue) {
            return this.value === dataValue;
        },
        handleClick(event) {
            let clickedItem = event.target.closest('.nav-item');
            let clickedValue = clickedItem.getAttribute('data-value');

            if (isMobileDevice()) {
                if (this.open && this.value === clickedValue) {
                    this.closeCategory();
                    return;
                }
            }

            this.value = clickedValue;
            this.openCategory();
        },
        openCategory() {
            this.open = true;
        },
        closeCategory() {
            this.open = false;
            this.value = '';
        },
        addToCart() {
            let app = this;
            app.store.setLoading('addToCart', app.$trans('storefront::image_editor.add_to_cart_loading'));

            let imageEditor = getImageEditor();
            imageEditor.save({callback: onSaveComplete});

            function onSaveComplete(data) {
                app.addToCartCustom(data)
                    .then(() => {
                        window.location.href = route('cart.index');
                    })
                    .catch(() => {}).finally(() => {
                    app.store.setLoadingFinished('addToCart');
                });
            }
        },
        handleCloseClick() {
            confirmClose();
        },
        settingCard_focus() {
            this.settingCardOpen = true;
            this.closeCategory();
        },
        settingCard_deFocus() {
            this.settingCardOpen = false;
        },
        settingCard_toggle() {
            if (!this.settingCardOpen) {
                this.settingCard_focus();
            } else {
                this.settingCard_deFocus();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @use "Themes/Storefront/resources/assets/public/sass/utils/_variables.scss" as var;

    .nav-item-vertical {
        max-width: 104px;
    }

    @media (max-width: var.$breakpoint-lg) {
        .side-nav {
            filter: drop-shadow(0 0 3px #00000014);
        }
    }
    @media (min-width: var.$breakpoint-lg) {
        .side-nav {
            min-width: 520px;
            overflow: auto;
        }

        .navigation-column {
            margin-top: 38px; margin-bottom: 38px;
            max-width:400px;
        }

        .dropdown-toggle-button {
            display: none;
        }
    }

    .dropdown-toggle-button {
        color: black;
        padding: 0px 24px;
        background: white;

        border-bottom: none;
        border-radius: 12px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
    .rotate-180 {
        transform: rotate(180deg);
    }
</style>
